import React from 'react';
import { SavePaymentProductsConnectorApollo } from '@front-activerse/common-components';
import CartAddContainer from './CartAddContainer';

interface ICartAddPage {
  pathCartSignUp: string;
  pathCartSavePayment: string;
}

const CartAddPage: React.FC<ICartAddPage> = ({ pathCartSignUp, pathCartSavePayment }) => {
  return (
    <SavePaymentProductsConnectorApollo>
      {({ savePaymentProduct }) => {
        return (
          <CartAddContainer
            savePaymentProduct={savePaymentProduct}
            pathCartSignUp={pathCartSignUp}
            pathCartSavePayment={pathCartSavePayment}
          />
        );
      }}
    </SavePaymentProductsConnectorApollo>
  );
};

export default CartAddPage;
